<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';

import type { PartnerPortalContactSessionFragmentFragment } from '@/graphql/pp/generated/graphql';

interface PartnerMenuProps {
  partner: PartnerPortalContactSessionFragmentFragment,
  partners: PartnerPortalContactSessionFragmentFragment[],
  setPartner:(value: PartnerPortalContactSessionFragmentFragment) => void,
}
const props = defineProps<PartnerMenuProps>();

const items = computed<DropdownMenuItem[]>(() => props.partners.map((item) => ({
  label: item.partner.school.school_name,
  onSelect: () => {
    props.setPartner(item);
  },
})));
</script>

<template>
  <UDropdownMenu
    :items="items"
    :content="{ align: 'start', side: 'bottom', sideOffset: 8 }"
    :ui="{
      content: 'z-50 min-w-56 max-w-xs',
      item: 'cursor-pointer',
    }"
    class="z-20 w-full max-w-full"
  >
    <button
      type="button"
      aria-label="Switch school"
      class="w-full max-w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-(--ui-primary) focus-visible:ring-opacity-75"
    >
      <div class="flex justify-between gap-2 items-center min-w-0">
        <div class="min-w-0 flex-1">
          <SchoolLogo
            :name="partner.partner.school.school_name"
            :logo="partner.partner.school.logo_url"
            class="h-10 max-h-10 max-w-full lg:h-12 lg:max-h-12"
          />
        </div>
        <div class="h-5 w-5 shrink-0 text-(--color-sidebar-menu-text)">
          <UiFaIcon
            :icon="['fal', 'chevron-down']"
            class="h-5 w-5"
            aria-hidden="true"
          />
        </div>
      </div>
    </button>
  </UDropdownMenu>
</template>
